import React, { useEffect, useState } from "react";
import PageContainer from "../../../components/PageContainer";
import RelatorioApiService from "../../../services/api/RelatorioApiService";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Table } from "react-bootstrap";
import { MdOutlineArrowBack, MdOutlineFileDownload } from "react-icons/md";
import { FiInfo } from 'react-icons/fi';
import UtilService from "../../../services/util";
import Loading from "../../../components/Loading";

function ResultadoDoClienteView(data) {
    const [visiblePopup, setVisiblePopup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [resultado, setResultado] = useState({});
    const [totaisGerais, setTotaisGerais] = useState({});
    const [totaisPorAno, setTotaisPorAno] = useState({});
    const [openProjetos, setOpenProjetos] = useState({});


    const popupStyle = {
        position: 'absolute',
        top: '-250%',
        left: '-70%',
        transform: 'translateX(-55%)',
        backgroundColor: '#e9e9e9',
        color: '#212529',
        border: '1px solid #dee2e6',
        borderRadius: '5px',
        padding: '5px 10px',
        zIndex: 1000,
        whiteSpace: 'nowrap',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        width: 'auto',
        fontWeight: 'normal'
    };

    const { anoSelecionado, dataInicial, dataFinal, clienteSelecionado, liderSelecionado } = data.location.state.data;
    const { clienteSelecionadoNome } = useParams();

    // Verifica se é filtro por líder ou por cliente
    const isLider = !!liderSelecionado;
    const filtroNome = isLider ? liderSelecionado : clienteSelecionadoNome;
    const filtroId = isLider ? liderSelecionado : clienteSelecionado;

    const handleDadosCliente = async () => {
        try {
            setLoading(true);
            let response;

            if (anoSelecionado) {
                // Se for líder, chama o serviço de líder, senão chama o de cliente
                if (isLider) {
                    response = await RelatorioApiService.getResultadoDoLiderTotal(liderSelecionado);
                } else {
                response = await RelatorioApiService.getResultadoDoClienteTotal(clienteSelecionado);
                }

                setResultado(response.data.result.result);
                setTotaisGerais(response.data.result.totaisGeraisAll);
                setTotaisPorAno(response.data.result.totaisPorAno);
            } else {
                // Extrai apenas o ano e mês no formato yyyy-MM
                const dataInicialObj = new Date(dataInicial);
                const dataFinalObj = new Date(dataFinal);

                const anoMesInicial = `${dataInicialObj.getFullYear()}-${String(dataInicialObj.getMonth() + 1).padStart(2, '0')}`;
                const anoMesFinal = `${dataFinalObj.getFullYear()}-${String(dataFinalObj.getMonth() + 1).padStart(2, '0')}`;

                // Se for líder, chama o serviço de líder, senão chama o de cliente
                if (isLider) {
                    response = await RelatorioApiService.getResultadoDoLiderPeriodo(anoMesInicial, anoMesFinal, liderSelecionado);
                } else {
                response = await RelatorioApiService.getResultadoDoClientePeriodo(anoMesInicial, anoMesFinal, clienteSelecionado);
                }

                setResultado(response.data.result.result);
                setTotaisGerais(response.data.result.totaisGeraisAll);
                setTotaisPorAno(response.data.result.totaisPorAno);
            }

        } catch (err) {
            console.error("Erro ao buscar dados", err);
        } finally {
            setLoading(false);
        }
    };

    // Função para exportar os dados do relatório para Excel
    const exportDataInExcel = async () => {
        // Define o cabeçalho com ou sem a coluna Cliente
        const header = isLider
            ? [['Cliente', 'Projeto', 'Ano', 'Mês', 'Receita Bruta Real', 'Receita Líquida Real', 'Custo Real', 'Total em Impostos', 'Despesas Operacionais', 'Resultado Líquido', 'Margem Líquida Mensal', 'Margem de Contribuição Mensal']]
            : [['Projeto', 'Ano', 'Mês', 'Receita Bruta Real', 'Receita Líquida Real', 'Custo Real', 'Total em Impostos', 'Despesas Operacionais', 'Resultado Líquido', 'Margem Líquida Mensal', 'Margem de Contribuição Mensal']];

        const formattedData = [];

        // Adicionar apenas dados detalhados por projeto, ano e mês
        Object.keys(resultado).forEach((projeto) => {
            // Aplica a mesma lógica de extração de cliente/projeto
            let nomeCliente = '';
            let nomeProjeto = projeto;

            if (projeto.includes(' - ')) {
                const partes = projeto.split(' - ');
                if (isLider) {
                    nomeCliente = partes[0];
                    nomeProjeto = partes[1];
                } else {
                    nomeProjeto = partes[1];
                }
            }

            Object.keys(resultado[projeto]).forEach((ano) => {
                Object.keys(resultado[projeto][ano]).forEach((mes) => {
                    const dadosMes = resultado[projeto][ano][mes][0];
                    const receitaBrutaReal = parseFloat(dadosMes?.receita_bruta) || 0;
                    const receitaLiquidaReal = parseFloat(dadosMes?.receita_liquida) || 0;
                    const totalImpostos = (receitaBrutaReal - receitaLiquidaReal) + (parseFloat(dadosMes?.imposto_sem_resultado) || 0);
                    const despesasOperacionais = parseFloat(dadosMes?.despesas_operacionais) || 0;
                    const row = isLider ? {
                        cliente: nomeCliente,
                        projeto: nomeProjeto,
                        ano: ano,
                        mes: mes,
                        receitaBrutaReal,
                        receitaLiquidaReal,
                        custoReal: parseFloat(dadosMes?.custo_venda) || 0,
                        totalImpostos,
                        despesasOperacionais,
                        resultadoLiquido: parseFloat(dadosMes?.resultado_liquido) || 0,
                        margemLiquidaMensal: parseFloat(dadosMes?.margem_liquida) || 0,
                        margemContribuicaoMensal: parseFloat(dadosMes?.margem_contribuicao) || 0
                    } : {
                        projeto: nomeProjeto,
                        ano: ano,
                        mes: mes,
                        receitaBrutaReal,
                        receitaLiquidaReal,
                        custoReal: parseFloat(dadosMes?.custo_venda) || 0,
                        totalImpostos,
                        despesasOperacionais,
                        resultadoLiquido: parseFloat(dadosMes?.resultado_liquido) || 0,
                        margemLiquidaMensal: parseFloat(dadosMes?.margem_liquida) || 0,
                        margemContribuicaoMensal: parseFloat(dadosMes?.margem_contribuicao) || 0
                    };
                    formattedData.push(row);
                });
            });
        });

        const tipoFiltro = isLider ? "Lider" : "Cliente";
        const nomeArquivo = `Resultado_${tipoFiltro}_${filtroNome}_${anoSelecionado || `${dataInicial}_${dataFinal}`}`;
        UtilService.exportXls(formattedData, nomeArquivo, header);
    };

    // Função para abrir e fechar os projetos
    const toggleProjeto = (projeto) => {
        setOpenProjetos(prev => ({ ...prev, [projeto]: !prev[projeto] }));
    };

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: useHistory().goBack
        }
    ];

    useEffect(() => {
        handleDadosCliente();
    }, []);

    // useEffect para inicializar a visibilidade dos projetos e anos
    useEffect(() => {
        if (Object.keys(resultado).length > 0) {
            // Inicializa todos os projetos como abertos
            const projetos = Object.keys(resultado);
            const projetosAbertos = Object.fromEntries(projetos.map(p => [p, true]));
            setOpenProjetos(projetosAbertos);

        }
    }, [resultado]);

    if (loading) {
        return (
            <PageContainer title={`Resultado do ${isLider ? 'Líder' : 'Cliente'} - ${filtroNome}`} actions={actions}>
                <Loading message="Carregando dados..." />
            </PageContainer>
        );
    }

    return (
        <PageContainer title={`Resultados do ${isLider ? 'Líder' : 'Cliente'} - ${filtroNome}`} actions={actions}>
            {Object.keys(resultado).length === 0 ? (
                <h5>Não existem dados para o período selecionado.</h5>
            ) : (
                <>
                    <Button onClick={() => exportDataInExcel()} className='mb-3'>Exportar</Button>
                    <Table bordered style={{ background: "#e1eaf3", width: "100%", tableLayout: "fixed" }} className="mb-4 mr-5 mt-2">
                        <thead>
                            <tr>
                                <th style={{ width: '4%' }}></th>
                                <th style={{ width: '10%' }}>Receita Bruta Total</th>
                                <th style={{ width: '10%' }}>Receita Líquida Total</th>
                                <th style={{ width: '10%' }}>Custo Total</th>
                                <th style={{ width: '10%' }}>Total em Impostos</th>
                                <th style={{ width: '10%' }}>Despesas Operacionais</th>
                                <th style={{ width: '10%' }}>
                                    Resultado Líquido Total
                                    <span onMouseEnter={() => setVisiblePopup('rl_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                        <FiInfo />
                                        {visiblePopup === 'rl_total' && <div className="hover-popup" style={popupStyle}>Resultado Líquido = Receita Líquida - Custo Total Real - Despesas Operacionais - Imposto s/ Resultado</div>}
                                    </span>
                                </th>
                                <th style={{ width: '13%' }}>
                                    Margem Líquida Total
                                    <span onMouseEnter={() => setVisiblePopup('ml_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                        <FiInfo />
                                        {visiblePopup === 'ml_total' && <div className="hover-popup" style={popupStyle}>Margem Líquida = Resultado Líquido / Receita Bruta</div>}
                                    </span>
                                </th>
                                <th style={{ width: '13%' }}>
                                    Margem de Contribuição Total
                                    <span onMouseEnter={() => setVisiblePopup('mc_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                        <FiInfo />
                                        {visiblePopup === 'mc_total' && <div className="hover-popup" style={{...popupStyle, left: 'auto', right: '0', transform: 'none'}}>Margem de Contribuição = (Receita Líquida - Custo Total Real) / Receita Líquida</div>}
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Total</b></td>
                                <td><b>{Number(totaisGerais?.receitaBrutaTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{Number(totaisGerais?.faturamentoLiquidoRealTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{Number(totaisGerais?.custoTotalRealTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{(((Number(totaisGerais?.receitaBrutaTotal) || 0) - (Number(totaisGerais?.faturamentoLiquidoRealTotal) || 0)) + (Number(totaisGerais?.impostoSobreResultadosTotal) || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{Number(totaisGerais?.despesasOperacionaisTotal || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{Number(totaisGerais?.resultadoLiquidoTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{Number(totaisGerais?.margemLiquidaMensalTotal).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                                <td><b>{Number(totaisGerais?.margemContribuicaoMensalTotal).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                            </tr>
                        </tbody>
                    </Table>
                    {Object.keys(resultado).length > 0 && (
                        Object.keys(resultado).map((projeto) => {
                            // Lógica de exibição do cliente e projeto
                            let nomeCliente = null;
                            let nomeProjeto = projeto;

                            if (projeto.includes(' - ')) {
                                const partes = projeto.split(' - ');
                                if (isLider) {
                                    // Se for líder, mostra cliente E projeto separados
                                    nomeCliente = partes[0];
                                    nomeProjeto = partes[1];
                                } else {
                                    // Se for cliente, mostra apenas o projeto (remove o cliente)
                                    nomeProjeto = partes[1];
                                }
                            }

                            return (
                                <div className="table table-bordered table-content p-3" key={projeto}>
                                    <div onClick={() => toggleProjeto(projeto)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        <div className='mr-2'>
                                            {nomeCliente && (
                                                <h5 className="mb-1"><b>Cliente: </b>{nomeCliente}</h5>
                                            )}
                                            <h5 className="mb-0"><b>Projeto: </b>{nomeProjeto}</h5>
                                        </div>
                                        <span style={{ marginLeft: 'auto' }}>{openProjetos[projeto] ? '▴' : '▾'}</span>
                                    </div>
                                {openProjetos[projeto] && (
                                    Object.keys(resultado[projeto]).map((ano) => (
                                    <div key={ano} className="mt-3 ml-2">
                                        <h5><b>Ano: </b>{ano}</h5>
                                        <Table striped bordered hover style={{ width: "100%", tableLayout: "fixed" }} className="mb-4 mr-5 mt-2">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '8%' }}>Mês</th>
                                                    <th style={{ width: '10%' }}>Receita Bruta Real</th>
                                                    <th style={{ width: '10%' }}>Receita Líquida Real</th>
                                                    <th style={{ width: '10%' }}>Custo Real</th>
                                                    <th style={{ width: '10%' }}>Total em Impostos</th>
                                                    <th style={{ width: '10%' }}>Despesas Operacionais</th>
                                                    <th style={{ width: '10%' }}>
                                                        Resultado Líquido
                                                        <span onMouseEnter={() => setVisiblePopup(`rl_${projeto}_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                            <FiInfo />
                                                            {visiblePopup === `rl_${projeto}_${ano}` && <div className="hover-popup" style={popupStyle}>Resultado Líquido = Receita Líquida - Custo Total Real - Despesas Operacionais - Imposto s/ Resultado</div>}
                                                        </span>
                                                    </th>
                                                    <th style={{ width: '16%' }}>
                                                        Margem Líquida Mensal
                                                        <span onMouseEnter={() => setVisiblePopup(`ml_${projeto}_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                            <FiInfo />
                                                            {visiblePopup === `ml_${projeto}_${ano}` && <div className="hover-popup" style={popupStyle}>Margem Líquida = Resultado Líquido / Receita Bruta</div>}
                                                        </span>
                                                    </th>
                                                    <th style={{ width: '16%' }}>
                                                        Margem de Contribuição Mensal
                                                        <span onMouseEnter={() => setVisiblePopup(`mc_${projeto}_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                            <FiInfo />
                                                            {visiblePopup === `mc_${projeto}_${ano}` && <div className="hover-popup" style={{...popupStyle, left: 'auto', right: '0', transform: 'none'}}>Margem de Contribuição = (Receita Líquida - Custo Total Real) / Receita Líquida</div>}
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(resultado[projeto][ano]).map((mes) => {
                                                    const d = resultado[projeto][ano][mes][0];
                                                    const impostosNF = (Number(d?.receita_bruta) || 0) - (Number(d?.receita_liquida) || 0);
                                                    const totalImpostos = impostosNF + (Number(d?.imposto_sem_resultado) || 0);
                                                    return (
                                                        <tr key={mes}>
                                                            <td style={{ width: '8%' }}>{mes}</td>
                                                            <td style={{ width: '10%' }}>{Number(d?.receita_bruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '10%' }}>{Number(d?.receita_liquida).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '10%' }}>{Number(d?.custo_venda).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '10%' }}>{totalImpostos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '10%' }}>{Number(d?.despesas_operacionais || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '10%' }}>{Number(d?.resultado_liquido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                            <td style={{ width: '16%' }}>{Number(d?.margem_liquida).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</td>
                                                            <td style={{ width: '16%' }}>{Number(d?.margem_contribuicao).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</td>
                                                        </tr>
                                                    );
                                                })}
                                                {(() => {
                                                    const ta = totaisPorAno[projeto][ano] || {};
                                                    const impostosNFAno = (Number(ta.receitaBrutaTotal) || 0) - (Number(ta.receitaLiquidaTotal) || 0);
                                                    const totalImpostosAno = impostosNFAno + (Number(ta.impostoSobreResultadosTotal) || 0);
                                                    return (
                                                        <tr>
                                                            <td style={{ width: '8%' }}><b>Total</b></td>
                                                            <td style={{ width: '10%' }}><b>{Number(ta.receitaBrutaTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '10%' }}><b>{Number(ta.receitaLiquidaTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '10%' }}><b>{Number(ta.totalCustoVenda).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '10%' }}><b>{totalImpostosAno.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '10%' }}><b>{Number(ta.despesasOperacionaisTotal || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '10%' }}><b>{Number(ta.resultadoLiquidoTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></td>
                                                            <td style={{ width: '16%' }}><b>{Number(ta.totalMargemLiquida).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                                                            <td style={{ width: '16%' }}><b>{Number(ta.totalMargemContribuicao).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                                                        </tr>
                                                    );
                                                })()}
                                            </tbody>
                                        </Table>
                                    </div>
                                )))}
                            </div>
                            );
                        })
                    )}
                </>
            )}
        </PageContainer>
    );
}

export default ResultadoDoClienteView;